enum Route {
  home = '/',
  treatment = '/treatment',
  clinic = '/clinic',
  district = '/district',
  patient = '/patient',
  practitioner = '/practitioner',
  appointment = '/appointment',
  contact = '/contact',
  success = '/success',
  bookNewAppointment = '/online-termin',
  bookByPhone = '/book-by-phone',
  upsell = '/upsell',
  phoneVerification = '/phone-verification',
  painDetails = '/pain-details',

  oldPatientPhoneVerification = '/old-patient-phone-verification',
  oldPatientSelectAccount = '/old-patient-select-account',
}

export default Route
